<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./OurCertificates.translations.json" with { type: "json" };
	import Formatted from "./common/Formatted.svelte";
	import StickySection from "./common/StickySection.svelte";

	const translate = getTranslate(translations);
</script>

<section class="full-width grid-container bg-zms-grey py-8 sm:py-12 md:py-16">
	<div class="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12">
		<div class="flex flex-col gap-4 sm:gap-6 lg:gap-10 text-start items-start">
			<StickySection class="py-2 sm:py-4 md:py-6">
				<h2 class="">
					<Formatted text={translate("heading")} />
				</h2>
			</StickySection>
		</div>
		<div class="flex flex-col gap-4 sm:gap-6 lg:gap-6">
			<div
				class="flex flex-col gap-4 sm:gap-6 md:gap-8 lg:gap-11 border-t border-zms-blue px-4 sm:px-6 py-6 sm:py-8 lg:py-10 bg-zms-grey"
			>
				<h3 class="text-zms-blue-dark text-lg sm:text-xl md:text-2xl lg:text-[2rem]/[1] font-semibold">
					<Formatted text={translate("gasDevicesTitle")} />
				</h3>
				<div class="flex flex-col gap-3 sm:gap-4 md:gap-6 lg:gap-7">
					<div class="flex items-start gap-2">
						<div class="w-1.5 h-1.5 rounded-full bg-zms-optical-black mt-2 shrink-0"></div>
						<p class="text-zms-optical-black text-sm sm:text-base md:text-lg lg:text-[1.125rem]/[1.4] font-semibold">
							<Formatted text={translate("gasDevicesAuth1")} />
						</p>
					</div>
					<div class="flex items-start gap-2">
						<div class="w-1.5 h-1.5 rounded-full bg-zms-optical-black mt-2 shrink-0"></div>
						<p class="text-zms-optical-black text-sm sm:text-base md:text-lg lg:text-[1.125rem]/[1.4] font-semibold">
							<Formatted text={translate("gasDevicesAuth2")} />
						</p>
					</div>
				</div>
			</div>
			<div
				class="flex flex-col gap-4 sm:gap-6 md:gap-8 lg:gap-11 border-t border-zms-blue px-4 sm:px-6 py-6 sm:py-8 lg:py-10 bg-zms-grey"
			>
				<h3 class="text-zms-blue-dark text-lg sm:text-xl md:text-2xl lg:text-[2rem]/[1] font-semibold">
					<Formatted text={translate("pressureDevicesTitle")} />
				</h3>
				<div class="flex flex-col gap-3 sm:gap-4 md:gap-6 lg:gap-7">
					<div class="flex items-start gap-2">
						<div class="w-1.5 h-1.5 rounded-full bg-zms-optical-black mt-2 shrink-0"></div>
						<p class="text-zms-optical-black text-sm sm:text-base md:text-lg lg:text-[1.125rem]/[1.4] font-semibold">
							<Formatted text={translate("pressureDevicesAuth1")} />
						</p>
					</div>
					<div class="flex items-start gap-2">
						<div class="w-1.5 h-1.5 rounded-full bg-zms-optical-black mt-2 shrink-0"></div>
						<p class="text-zms-optical-black text-sm sm:text-base md:text-lg lg:text-[1.125rem]/[1.4] font-semibold">
							<Formatted text={translate("pressureDevicesAuth2")} />
						</p>
					</div>
				</div>
			</div>
			<div
				class="flex flex-col gap-4 sm:gap-6 md:gap-8 lg:gap-11 border-t border-zms-blue px-4 sm:px-6 py-6 sm:py-8 lg:py-10 bg-zms-grey"
			>
				<h3 class="text-zms-blue-dark text-lg sm:text-xl md:text-2xl lg:text-[2rem]/[1] font-semibold">
					<Formatted text={translate("electricDevicesTitle")} />
				</h3>
				<div class="flex flex-col gap-3 sm:gap-4 md:gap-6 lg:gap-7">
					<div class="flex items-start gap-2">
						<div class="w-1.5 h-1.5 rounded-full bg-zms-optical-black mt-2 shrink-0"></div>
						<p class="text-zms-optical-black text-sm sm:text-base md:text-lg lg:text-[1.125rem]/[1.4] font-semibold">
							<Formatted text={translate("electricDevicesAuth")} />
						</p>
					</div>
				</div>
			</div>
			<div
				class="flex flex-col gap-4 sm:gap-6 md:gap-8 lg:gap-11 border-t border-zms-blue px-4 sm:px-6 py-6 sm:py-8 lg:py-10 bg-zms-grey"
			>
				<h3 class="text-zms-blue-dark text-lg sm:text-xl md:text-2xl lg:text-[2rem]/[1] font-semibold">
					<Formatted text={translate("kaeserCompressorsTitle")} />
				</h3>
				<div class="flex flex-col gap-3 sm:gap-4 md:gap-6 lg:gap-7">
					<div class="flex items-start gap-2">
						<div class="w-1.5 h-1.5 rounded-full bg-zms-optical-black mt-2 shrink-0"></div>
						<p class="text-zms-optical-black text-sm sm:text-base md:text-lg lg:text-[1.125rem]/[1.4] font-semibold">
							<Formatted text={translate("kaeserCompressorsAuth")} />
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
